import { RootState } from 'data/root.reducers';
import { JurisdictionArea, JurisdictionAreaGridData } from './jurisdictionArea.types';

export const getJurisdictionAreaList = (state: RootState): JurisdictionArea[] =>
  state.jurisdictionArea.entities;

export const getSelectedJurisdictionArea = (state: RootState): JurisdictionAreaGridData[] =>
  state.jurisdictionArea.selected;

export const isJurisdictionAreaEditPopupOpen = (state: RootState): boolean =>
  state.jurisdictionArea.ui.isEditPopupOpen;
